// extracted by mini-css-extract-plugin
module.exports = {"container":"server-paginated-table_container__3Yxop","toolbar":"server-paginated-table_toolbar__355yR"};